export const NAV = {
  home: "nav-home-link",
  about: "nav-about-link",
  divisions: "nav-divisions-link",
  subsidiaries: "nav-subsidiaries-link",
  fleet: "nav-fleet-link",
  careers: "nav-careers-link",
  contact: "nav-contact-link",
  admin: "nav-admin-link",
  logo: "nav-logo",
};

export const HERO = {
  exploreBtn: "hero-explore-divisions-btn",
  rfqBtn: "hero-submit-rfq-btn",
};

export const DIV = {
  card: (id) => `division-card-${id}`,
  viewBtn: (id) => `division-view-btn-${id}`,
};

export const SUB = {
  card: (slug) => `subsidiary-card-${slug}`,
  requestBtn: (slug) => `subsidiary-request-btn-${slug}`,
  searchInput: "subsidiary-search-input",
  categoryFilter: (cat) => `subsidiary-cat-${cat}`,
};

export const RFQ_FORM = {
  companyName: "rfq-company-name",
  contactName: "rfq-contact-name",
  contactEmail: "rfq-contact-email",
  contactPhone: "rfq-contact-phone",
  region: "rfq-region-select",
  divisionCheckbox: (id) => `rfq-division-${id}`,
  projectScope: "rfq-project-scope",
  startDate: "rfq-start-date",
  submit: "rfq-submit-btn",
};

export const CAREER_FORM = {
  fullName: "career-full-name",
  email: "career-email",
  phone: "career-phone",
  position: "career-position",
  divisionPref: "career-division-pref",
  yearsExp: "career-years-exp",
  certifications: "career-certifications",
  coverLetter: "career-cover-letter",
  resumeUrl: "career-resume-url",
  submit: "career-submit-btn",
};

export const CONTACT_FORM = {
  name: "contact-name",
  email: "contact-email",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit-btn",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit-btn",
  logout: "admin-logout-btn",
  tabRfq: "admin-tab-rfq",
  tabCareers: "admin-tab-careers",
  tabMessages: "admin-tab-messages",
  tabSubs: "admin-tab-subs",
  rfqRow: (id) => `admin-rfq-row-${id}`,
  careerRow: (id) => `admin-career-row-${id}`,
  subRow: (id) => `admin-sub-row-${id}`,
  subEditBtn: (id) => `admin-sub-edit-btn-${id}`,
  subDeleteBtn: (id) => `admin-sub-delete-btn-${id}`,
  rfqStatusSelect: (id) => `admin-rfq-status-select-${id}`,
  careerStatusSelect: (id) => `admin-career-status-select-${id}`,
  statusSelect: (id) => `admin-status-select-${id}`,
  rfqDeleteBtn: (id) => `admin-rfq-delete-btn-${id}`,
  careerDeleteBtn: (id) => `admin-career-delete-btn-${id}`,
  deleteBtn: (id) => `admin-delete-btn-${id}`,
};
